import { buildLoggerInit, logger } from './base.js';
import { initDatadog } from './datadog.client.js';

if (typeof global === 'undefined') {
  window.global = window;
}

const init = buildLoggerInit(() =>
  process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ? initDatadog : undefined,
);

// Initialize right away
init();

// Allow for reinit, mostly for testing but also if env vars change
export { init as reinit, logger };

export * from './rum.js';
